module.exports = "<div>\r\n    <p>{{msgError}}</p>\r\n    <p>Seleccione capas de <b>información disponible</b></P>\r\n</div>\r\n";